<template>
    <nav class="kb-mobile-navigation-items">
        <ul class="kb-mobile-navigation-items__mainmenulist">
            <li v-for="(item, $index) in items" v-bind:key="item.linkText" class="kb-mobile-navigation-items__mainmenuitem">
                <div class="kb-mobile-navigation-items__mainmenulink-wrapper">
                    <kb-base-link :href="item.url" class="kb-mobile-navigation-items__mainmenulink jt-header-navi-main" :link-props="{title: item.linkText,  target: item.target}">{{ item.linkText }}</kb-base-link>
                    <kb-icon-button
                        v-on:click.native="toggle($index)"
                        v-if="item.children && item.children.length"
                        :icon="isSubmenuOpen($index) ? 'chevron-up' : 'chevron-down'"
                        color="primary"
                        size="small"
                    />
                </div>
                <ul v-if="item.children" class="kb-mobile-navigation-items__submenulist" :class="(isSubmenuOpen($index)) ? 'kb-mobile-navigation-items__submenulist--open' : ''">
                    <li v-bind:key="subitem.linkText" v-for="subitem in item.children" class="kb-mobile-navigation-items__submenuitem">
                        <kb-base-link :href="subitem.url" class="kb-mobile-navigation-items__submenulink jt-header-navi-sub" :link-props="{title: subitem.linkText,  target: subitem.target}">{{ subitem.linkText }}</kb-base-link>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'kb-mobile-navigation-items',
    props: {
        items: {
            required: true,
            type: Array
        }
    },
    data: function() {
        return {
            openSubmenus: []
        }
    },
    methods: {
        toggle: function(index) {
            if(this.openSubmenus.indexOf(index) === -1) {
                this.openSubmenus.push(index)
            } else {
                this.openSubmenus.splice(this.openSubmenus.indexOf(index), 1);
            }
        },
        isSubmenuOpen: function(index) {
            return (this.openSubmenus.indexOf(index) !== -1);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors';

.kb-mobile-navigation-items {

    &__mainmenulist,
    &__submenulist {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    &__submenulist {
        display: none;

        &--open {
            display: block;
        }
    }

    &__mainmenuitem {
        &:first-child {
            border-top: 1px solid $grey-lighter;
        }

        border-bottom: 1px solid $grey-lighter;
    }

    &__mainmenulink-wrapper {
        display: flex;
        align-items: center;
    }

    &__mainmenulink {
        display: block;
        font-family: $fontFamilyRegular;
        font-weight: $fontWeightBold;
        text-decoration: none;
        color: $cTextPrimary;
        flex-grow: 1;
        padding: $spacingRegular 0;
    }

    &__submenulink {
        display: block;
        font-family: $fontFamilyRegular;
        text-decoration: none;
        color: $cTextPrimary;
        margin-bottom: $spacingSm;
        padding-left: $spacingSm;
    }
}
</style>
